import { render, staticRenderFns } from "./integral-list.vue?vue&type=template&id=1dec41e6&scoped=true&"
import script from "./integral-list.vue?vue&type=script&lang=js&"
export * from "./integral-list.vue?vue&type=script&lang=js&"
import style0 from "./integral-list.vue?vue&type=style&index=0&id=1dec41e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dec41e6",
  null
  
)

export default component.exports